<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [(ngModel)]="daysAgoActual" placeholder="Seleccionar Periodo"
    (select)="changeDaysAgo($event)">

    <ng-template ngx-select-option let-option>
        <span [class.selected]="isSelected(option)" [class.ngx-select-option-selected]="isSelected(option)">{{option.text}}</span>
    </ng-template>

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>